import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "originAddressField",
    "originAddressComplementField",
    "firstTargetAddressField",
    "firstTargetAddressComplementField",
    "secondTargetAddressField",
    "secondTargetAddressComplementField"
  ]

  copyOriginToTarget (event) {
    const item = event.currentTarget.closest(".nested-form__item")
    const targetInput = item?.querySelector("[data-copy-address-fields-target='targetAddressField']")
    if (!targetInput || !this.hasOriginAddressFieldTarget) return

    this._copyAddressInput(this.originAddressFieldTarget, targetInput)
  }

  copyOriginToFirstTarget () {
    const targetInput = this.firstTargetAddressFieldTargets[0]
    if (!targetInput) return

    this._copyAddressInput(this.originAddressFieldTarget, targetInput)
  }

  copyOriginToSecondTarget () {
    this._copyAddressInput(this.originAddressFieldTarget, this.secondTargetAddressFieldTarget)

    if (this.hasOriginAddressComplementFieldTarget && this.hasSecondTargetAddressComplementFieldTarget) {
      this.secondTargetAddressComplementFieldTarget.value = this.originAddressComplementFieldTarget.value
    }
  }

  _copyAddressInput (sourceInput, targetInput) {
    if (!sourceInput || !targetInput) return

    targetInput.value = sourceInput.value
    this._syncHiddenFields(sourceInput, targetInput)
  }

  _syncHiddenFields (sourceInput, targetInput) {
    const sourceContainer = sourceInput.closest("[data-controller~='address-autocomplete']")
    const targetContainer = targetInput.closest("[data-controller~='address-autocomplete']")

    if (!sourceContainer || !targetContainer) return

    const sourceInputs = sourceContainer.querySelectorAll("input[type='hidden']")
    const targetInputs = targetContainer.querySelectorAll("input[type='hidden']")

    sourceInputs.forEach((sourceField, index) => {
      const targetField = targetInputs[index]
      if (!targetField) return

      if (targetField.type === "checkbox" || targetField.type === "radio") {
        targetField.checked = sourceField.checked
      } else {
        targetField.value = sourceField.value
      }
    })
  }
}
